export default "__VITE_ASSET__380a66c4__"